import React from 'react';
import Lottie from 'react-lottie-player';
import sunnyAnim from '../assets/lottie/sunny.json';
import cloudyAnim from '../assets/lottie/cloudy.json';
import rainAnim from '../assets/lottie/rain.json';
import snowAnim from '../assets/lottie/snow.json';
import fogAnim from '../assets/lottie/fog.json';
import stormAnim from '../assets/lottie/storm.json';
import nightAnim from '../assets/lottie/night.json';

// Tipe cuaca yang didukung
export type WeatherType = 'clear' | 'cloudy' | 'rain' | 'snow' | 'fog' | 'extreme' | 'night';

const animMap: Record<WeatherType, any> = {
  clear: sunnyAnim,
  cloudy: cloudyAnim,
  rain: rainAnim,
  snow: snowAnim,
  fog: fogAnim,
  extreme: stormAnim,
  night: nightAnim,
};

export default function WeatherBackground({ mood }: { mood: string }) {
  // Map mood string ke WeatherType
  let weather: WeatherType = 'clear';
  if (mood === 'cloudy') weather = 'cloudy';
  else if (mood === 'rain') weather = 'rain';
  else if (mood === 'snow') weather = 'snow';
  else if (mood === 'fog') weather = 'fog';
  else if (mood === 'thunder' || mood === 'extreme') weather = 'extreme';
  else if (mood === 'night') weather = 'night';
  else weather = 'clear';

  const animationData = animMap[weather] || sunnyAnim;
  return (
    <div style={{
      position: 'fixed',
      zIndex: 0,
      inset: 0,
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      pointerEvents: 'none',
      background: weather === 'night' ? '#181825' : undefined,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          pointerEvents: 'none',
          marginTop: 180,
        }}
      >
        <Lottie
          loop
          play
          animationData={animationData}
          style={{ width: '100%', maxWidth: 300, height: 'auto' }}  
          speed={0.5}
        />
      </div>
    </div>
  );
}
